'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var getSystem = require('@mx/util/get-system');

/**
 * Device Info
 */
var system = getSystem.getSystem();
var deviceInfo = {};
function onResize() {
    deviceInfo.winWidth = window.innerWidth;
    deviceInfo.winHeight = window.innerHeight;
}
if (system !== 'node') {
    onResize();
    window.addEventListener('resize', onResize);
}

exports.deviceInfo = deviceInfo;
